import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
}
export function Accordion({
  title,
  children,
  defaultOpen = false,
  className = ''
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className={`border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow ${className}`} data-id="element-15">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-3 md:p-5 text-left focus:outline-none focus:ring-2 focus:ring-primary/50" aria-expanded={isOpen} data-id="element-16">
        <div className="flex-1 pr-3 md:pr-4" data-id="element-17">{title}</div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 text-gray-400" data-id="element-18">
          <ChevronDown className="w-5 h-5 md:w-6 md:h-6" data-id="element-19" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-20">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-21">
            <div className="p-3 md:p-5 pt-0 border-t border-gray-100 bg-gray-50/50" data-id="element-22">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}